"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailDto = exports.EmailAttachmentDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const is_file_uri_1 = require("../decorators/is-file-uri");
class EmailAttachmentDto {
}
__decorate([
    (0, is_file_uri_1.IsFileUri)(),
    __metadata("design:type", String)
], EmailAttachmentDto.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MinLength)(5),
    __metadata("design:type", String)
], EmailAttachmentDto.prototype, "fileName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsMimeType)(),
    __metadata("design:type", String)
], EmailAttachmentDto.prototype, "contentType", void 0);
exports.EmailAttachmentDto = EmailAttachmentDto;
class SendEmailDto {
}
__decorate([
    (0, class_validator_1.IsEmail)({ allow_display_name: true }),
    __metadata("design:type", String)
], SendEmailDto.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)({ allow_display_name: true }),
    __metadata("design:type", String)
], SendEmailDto.prototype, "replyTo", void 0);
__decorate([
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEmail)({ allow_display_name: true }, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "to", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)({ allow_display_name: true }, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "cc", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)({ allow_display_name: true }, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "bcc", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.ValidateIf)((email) => !email.render),
    __metadata("design:type", String)
], SendEmailDto.prototype, "subject", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    __metadata("design:type", String)
], SendEmailDto.prototype, "template", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SendEmailDto.prototype, "render", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateIf)((email) => email.render),
    __metadata("design:type", Object)
], SendEmailDto.prototype, "context", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(10),
    (0, class_validator_1.ValidateIf)((email) => !email.render),
    __metadata("design:type", String)
], SendEmailDto.prototype, "bodyHtml", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(10),
    __metadata("design:type", String)
], SendEmailDto.prototype, "bodyText", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => EmailAttachmentDto),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "attachments", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(15, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "linkToJobs", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(15, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "linkToAccounts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(15, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "linkToContacts", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }, { each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    __metadata("design:type", Array)
], SendEmailDto.prototype, "linkToAccountingDocuments", void 0);
exports.SendEmailDto = SendEmailDto;
//# sourceMappingURL=send-email.js.map